import { Fragment, useContext, useEffect, useState } from 'react';
import { Location, To, useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Drawer, MenuList, MenuItem, ListItemText, ListItemIcon, Collapse } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';

import { ctxUser } from '@/contexts/UserContext';
import { getAdditionalElements } from '@/popups';
import { PopupType } from '@/types';

export default function More({
  closePopup,
  hasTachograph,
}: {
  closePopup: () => Promise<void>;
  hasTachograph?: boolean;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const userCtx = useContext(ctxUser);
  const { t } = useTranslation();
  const addElementsList = getAdditionalElements(closePopup, true, hasTachograph);
  const [open, setOpen] = useState(false);
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState<number | null>(null);

  const handleToggleSubmenu = (index: number) => {
    setOpenSubmenuIndex((prev) => (prev === index ? null : index));
  };

  // ez nem fut le ???
  // mert a drawer close-nal nem is kell ??
  // ez nem a popup close-a !!!!
  async function onClose() {}

  // ez ugyanaz mint a LeftNav-nal ??
  function getNav(p: PopupType, location: Location) {
    if (p.level === 1) return p.navigateTo || p.path;

    // ha en vagyok az aktiv es a more vagyok :( ez sajnos most be van egetve
    if (p.navigateTo && location.pathname.endsWith(p.navigateTo)) return -1;

    // ha en vagyok az aktiv akkor nem csinal semmit
    if (location.pathname.endsWith(p.path)) return location.pathname;

    // nem en vagyok az aktiv
    // mi van ha az elso resz nem a tracking vagy a route ?? ha a reports-rol jon ???
    const parts = location.pathname.split('/'); // regex lehet jobb lenne
    if (parts.length === 2) {
      // a nulladik elem ures string :(
      return location.pathname + '/' + p.path;
    }
    return '/' + parts[1] + '/' + p.path;
  }

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
    });
  }, []);

  // ezek a filterek nem ide kellenenek ???
  const elements = addElementsList.filter((e) => !userCtx?.isToken() || e.showToken);

  // animalva jelenik meg ???
  return (
    <Drawer
      variant="persistent"
      hideBackdrop
      disableEnforceFocus
      disablePortal
      anchor="bottom"
      transitionDuration={0}
      open={open}
      ModalProps={{
        keepMounted: false,
        onClose,
      }}
      slotProps={{
        root: { sx: { zIndex: 1300 } }, // butan nez ki ahogy animal, lehetne megint magas de hatrebb
        paper: {
          id: 'more_menu_drawer',
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            bottom: '56px',
            // paddingBottom: '60px',
            overflowY: 'auto',
          },
        },
      }}
    >
      <MenuList>
        {elements
          .filter((p) => {
            const requiredExtraFeature = p.requiredExtraFeature;
            if (!requiredExtraFeature) {
              return true;
            }
            return userCtx?.hasExtraFeature(requiredExtraFeature);
          })
          .filter((p) => p.showMobile)
          .map((e, index) => {
            const hasChildren = Array.isArray(e.children) && e.children.length > 0;
            const isOpen = openSubmenuIndex === index;

            if (e.children && userCtx?.isToken()) {
              e.children = e.children.filter((c) => c.showToken);
            }

            return (
              <Fragment key={e.title}>
                <MenuItem
                  onClick={
                    hasChildren
                      ? () => handleToggleSubmenu(index)
                      : e.element
                        ? async () => await navigate(getNav(e, location) as To, { replace: true })
                        : async () => await navigate('/logout')
                  }
                  data-qa-element-id={e.dataQaElementId}
                >
                  <ListItemIcon>{e.icon}</ListItemIcon>
                  <ListItemText data-qa-element-id={`menu_item_text_${e.title}`}>{t(e.title!)}</ListItemText>

                  {hasChildren && (
                    <KeyboardArrowRight
                      sx={{
                        ml: 'auto',
                        transition: 'transform 0.2s ease',
                        transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                      }}
                    />
                  )}
                </MenuItem>
                {hasChildren && (
                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <MenuList sx={{ pl: 4 }} data-qa-element-id={`submenu_for_${e.dataQaElementId}`}>
                      {e.children?.map((child) => (
                        <MenuItem
                          key={child.title}
                          onClick={
                            child.element
                              ? async () => await navigate(getNav(child, location) as To, { replace: true })
                              : async () => await navigate('/logout')
                          }
                          data-qa-element-id={`submenu_${child.dataQaElementId}`}
                        >
                          <ListItemIcon>{child.icon}</ListItemIcon>
                          <ListItemText data-qa-element-id={`menu_item_text_${e.title}`}>
                            {t(child.title!)}
                          </ListItemText>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Collapse>
                )}
              </Fragment>
            );
          })}
      </MenuList>
    </Drawer>
  );
}
